import React from 'react';

import {
  ImageBackground,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../../config/constants';

import './style.scss';

const ParagraphImageGrid = ({ id, entity, wide }) => {
  const mediaItems = entity.get('field_media_items');
  const body = entity.getIn(['field_body', 0, 'value']);

  return (
    <Container id={id} className="Paragraph ParagraphImageGrid">
      <div className="row">
        <div className={`ParagraphImageGrid__inner col-12 ${!wide && 'col-md-10 offset-md-1 col-lg-10 offset-lg-1'}`}>
          {
            mediaItems && (
              <div className="ImageItems">
                {mediaItems.get(0) && (
                  <ImageBackground
                    src={{
                      [SCREEN_MOBILE]: mediaItems.getIn([0, 'styles', 'image_grid_square_tablet']),
                      [SCREEN_NORMAL]: mediaItems.getIn([0, 'styles', 'image_grid_square_desktop']),
                    }}
                    alt="Image 1"
                  />
                )}
                {mediaItems.get(1) && (
                  <ImageBackground
                    src={{
                      [SCREEN_MOBILE]: mediaItems.getIn([1, 'styles', 'image_grid_landscape_tablet']),
                      [SCREEN_NORMAL]: mediaItems.getIn([1, 'styles', 'image_grid_landscape_desktop']),
                    }}
                    alt="Image 2"
                  />
                )}
                {mediaItems.get(2) && (
                  <ImageBackground
                    src={{
                      [SCREEN_MOBILE]: mediaItems.getIn([2, 'styles', 'image_grid_landscape_tablet']),
                      [SCREEN_NORMAL]: mediaItems.getIn([2, 'styles', 'image_grid_landscape_desktop']),
                    }}
                    alt="Image 3"
                  />
                )}
              </div>
            )
          }
          {body && (
            <p className="ParagraphImageGrid__caption">{body}</p>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphImageGrid;
